<script lang="ts" setup>import { computed as _computed } from 'vue';

import { getActiveCategories } from '@consumer/logic/v2/header'
import { faTreeChristmas } from '@fortawesome/pro-light-svg-icons'
import xmasTreeRiveUrl from '@consumer/assets/images/header-v2/rive/xmas_tree.riv?url'
import CategoryBarDesktop from './CategoryBarDesktop.vue'
import CategoryBarMobile from './CategoryBarMobile.vue'

const currentTheme = inject('currentTheme')
const suppressIcon = true

const categories = _computed(() => {
  let allCategories = getActiveCategories()
  if (currentTheme === 'holidays') {
    allCategories = [
      {
        title: 'Christmas',
        icon: faTreeChristmas,
        riveUrl: xmasTreeRiveUrl,
        path: '/gifts/christmas?spec=site-nav',
        inactiveColorName: '--color-text-christmas-red',
        activeColorName: '--color-text-christmas-red',
      },
      ...allCategories,
    ]
  }

  allCategories = allCategories.map((category) => {
    if (suppressIcon) {
      if (category.title === 'Quick Gift' || category.title === 'Birthday Gifts') {
        return category
      }
      else
        return {
          ...category,
          icon: undefined,
          riveUrl: undefined,
        }
    }
    else {
      if (category.title === 'Quick Gift' || category.title === 'Birthday Gifts') {
        return {
          ...category,
          gradientName: undefined,
        }
      }
      else return category
    }
  })
  return allCategories
})
</script>

<template>
  <div
    class="relative bg-white transition-all duration-250 v2-header-category-bar max-w-md mx-auto"
  >
    <V2Container class="flex items-center justify-between z-navbar !max-w-full pt-2 !px-0">
      <CategoryBarMobile
        class="lg:hidden"
        :categories="categories"
        iconLayout="row"
      />
      <CategoryBarDesktop
        class="hidden lg:flex"
        :categories="categories"
        iconLayout="row"
      />
    </V2Container>
  </div>
</template>
